
/**
 * Returns the val's type.
 *
 * @param string 	val
 *
 * @return string
 */
export default function(val) {
	return typeof val;
};
